export default {
    ...require("./pt/applepay.json"),
    ...require("./pt/bank.json"),
    ...require("./pt/banktransfer.json"),
    ...require("./pt/barter.json"),
    ...require("./pt/card.json"),
    ...require("./pt/cryptocurrency"),
    ...require("./pt/eNaira.json"),
    ...require("./pt/fawrypay.json"),
    ...require("./pt/googlepay.json"),
    ...require("./pt/internet-banking.json"),
    ...require("./pt/mobile-money.json"),
    ...require("./pt/mpesa.json"),
    ...require("./pt/nqr.json"),
    ...require("./pt/migo.json"),
    ...require("./pt/paga.json"),
    ...require("./pt/payattitude.json"),
    ...require("./pt/paypal.json"),
    ...require("./pt/plaid.json"),
    ...require("./pt/qr.json"),
    ...require("./pt/ussd.json"),
    ...require("./pt/voucher.json"),
    ...require("./pt/wechat.json"),
    ...require("./pt/ui.json"),
    ...require("./pt/paymenterrors.json"),
    ...require("./pt/init.json"),
    ...require("./pt/instructions.json"),
    ...require("./pt/paymentoptions.json"),
    ...require("./pt/opay.json"),
    ...require("./pt/capitec.json"),
};